import { BrandsSubscriptionsOption } from 'owa-brands-subscriptions-option';
import { OptionSubCategory } from 'owa-options-core';

const brandsSubscriptionsSubCategory: OptionSubCategory = {
    key: 'brandsSubscriptions',
    titleStringKey: 'optionTitle_subscriptionActions',
    options: [BrandsSubscriptionsOption],
};

export default brandsSubscriptionsSubCategory;
